import { render, staticRenderFns } from "./NavbarDropdown.vue?vue&type=template&id=5b4289ee"
import script from "./NavbarDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarDropdown.vue?vue&type=style&index=0&id=5b4289ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports